// extracted by mini-css-extract-plugin
export default {"root":"bEnFUlKLQh","tab":"raeXxn_HwV","tab_active":"YMYpxCGxm0"};